<template>
  <div style="display: flex; justify-content: space-between">
    <h5>
      <span style="display: flex">
        <span class="hPoints bg-alerta">{{ somatoriaHP[0] }}</span>
        <span class="hPoints bg-ok">{{ somatoriaHP[1] }}</span>
        <span class="hPoints bg-sucesso">{{ somatoriaHP[2] }}</span>
      </span>
    </h5>
    <div>
      <button v-if="podeAdicionarTarefa" type="button" @click="$emit('adicionarTarefa')">
        Adicionar Tarefa
      </button>
    </div>
    <div>
      <strong> Mostrando {{ total }} {{ total === 1 ? 'tarefa' : 'tarefas' }} </strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumoHP',
  props: {
    somatoriaHP: { type: Array, default: () => [0, 0, 0] },
    total: { type: Number, default: 0 },
    podeAdicionarTarefa: { type: Boolean, default: false },
  },
  emits: ['adicionarTarefa'],
};
</script>
